<template>
    <div class="login-recover-register-page">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-md-5 left-content">
                    <div class="back-button">
                        <router-link :to="sidebar.back.link">
                            <div class="back">
                                <button :class="`btn btn-${getIsDarkTheme ? 'light' : 'dark'}`">
                                    <i class="fas fa-chevron-left"></i>
                                </button>
                                <span>{{ sidebar.back.text }}</span>
                            </div>
                        </router-link>
                    </div>

                    <div class="title">
                        <h2>{{ sidebar.title }}</h2>
                    </div>

                    <div class="subtitle">{{ sidebar.subtitle }}</div>

                    <div class="img" v-if="sidebar.img">
                        <img :src="require(`@/assets/${sidebar.img}.svg`)" :alt="sidebar.img" />
                    </div>
                </div>

                <div class="col-12 col-md-7 right-content">
                    <div class="content">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentPath: null,
            sidebar: {
                back: {
                    text: 'Voltar',
                    link: '#'
                },
                title: '',
                subtitle: '',
                img: null
            }
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        }
    },
    methods: {
        fetchSidebarData() {
            if (this.$router.history.current.path !== this.currentPath) {
                switch (this.$router.history.current.path) {
                    case '/admin/login':
                    case '/login':
                        this.currentPath = this.$router.history.current.path
                        this.sidebar.back.text = 'Voltar para o site'
                        this.sidebar.back.link = '/'
                        this.sidebar.title = 'Plataforma Potências Periféricas'
                        this.sidebar.subtitle =
                            'Somos uma plataforma com o objetivo de promover encontros e qualificar ainda mais as doações e parcerias que sejam direcionadas às periferias no Brasil.'
                        this.sidebar.img = !this.getIsDarkTheme ? 'login-page-img-01' : 'login-page-img-01-dark'
                        break

                    case '/recuperarsenha':
                        this.currentPath = this.$router.history.current.path
                        this.sidebar.back.text = 'Voltar para o login'
                        this.sidebar.back.link = '/login'
                        this.sidebar.title = 'Esquecer a senha não é um problema!'
                        this.sidebar.subtitle =
                            'Esqueceu a sua senha? Não tem problema, basta solicitar a criação da nova senha informando o seu e-mail cadastrado.'
                        this.sidebar.img = !this.getIsDarkTheme
                            ? 'recover-password-page-img-01'
                            : 'recover-password-page-img-01-dark'
                        break

                    case '/nova-senha':
                        this.currentPath = this.$router.history.current.path
                        this.sidebar.back.text = 'Voltar para o login'
                        this.sidebar.back.link = '/login'
                        this.sidebar.title = 'Pode alterar a sua senha a qualquer momento.'
                        this.sidebar.subtitle =
                            'É importante alterar a senha de tempo em tempo para aumentar a sua segurança ou toda vez que acha um terceiro viu a sua senha.'
                        this.sidebar.img = !this.getIsDarkTheme
                            ? 'recover-password-page-img-01'
                            : 'recover-password-page-img-01-dark'
                        break

                    case '/cadastrar':
                        this.currentPath = this.$router.history.current.path
                        this.sidebar.back.text = 'Voltar para o site'
                        this.sidebar.back.link = '/'
                        this.sidebar.title = 'Cadastre-se na platafoma. '
                        this.sidebar.subtitle =
                            'Apoiar as periferias é inverter uma lógica e ajudar a reduzir desiguadades, é aplicar as possibilidades de impacto, é promover mais diversidade, inclusão e justiça.'
                        this.sidebar.img = 'register-page-img-01'
                        break

                    default:
                        break
                }
            }
        }
    },
    updated() {
        this.fetchSidebarData()
    },
    mounted() {
        this.fetchSidebarData()
    }
}
</script>

<style scope src="./LoginRecoverRegisterPage-light-theme.css"></style>
<style scope src="./LoginRecoverRegisterPage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/login-recover-register-page/LoginRecoverRegisterPage.vue